import { comments, cards, ranking, topics } from '@/mocks/homeData';

export function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            影迷心声
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            看看大家都在说什么
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            来自真实影迷的评价，四虎影视大全用品质赢得口碑
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((c) => (
            <div key={c.id} className="bg-background-100 rounded-xl p-5 md:p-6 flex gap-4">
              <img
                src={c.avatar}
                alt={c.name}
                className="w-12 h-12 rounded-full object-cover flex-shrink-0"
                loading="lazy"
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1 flex-wrap gap-2">
                  <h3 className="font-semibold text-sm text-foreground-900">{c.name}</h3>
                  <span className="text-xs text-foreground-500">{c.time}</span>
                </div>
                <div className="flex items-center gap-1 mb-2">
                  {Array.from({ length: c.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-2">{c.content}</p>
                <span className="inline-block text-xs text-primary-600 bg-primary-50 px-2 py-0.5 rounded">
                  {c.movie}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            分类推荐
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            探索你的观影口味
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            六大分类精选，总有一款适合你此刻的心情
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <a
              key={card.id}
              href="#ranking"
              className="group bg-background-50 rounded-xl overflow-hidden block no-underline cursor-pointer transition-colors hover:bg-background-200/30"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={`四虎影视大全${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-medium bg-background-50/90 text-foreground-900 rounded-md">
                    {card.category}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-semibold bg-primary-500 text-white rounded-md">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            热播榜单
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            本周热门电影排行
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            根据播放量与用户评分综合排序，实时反映最受欢迎影片
          </p>
        </div>

        <div className="space-y-3">
          {ranking.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 hover:bg-background-200/60 transition-colors cursor-pointer no-underline"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base whitespace-nowrap truncate">{item.title}</h3>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500 text-sm"></i>
                  <span className="text-sm font-bold text-foreground-900">{item.score}</span>
                </div>
                <div className="w-6 h-6 flex items-center justify-center">
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-green-500 text-sm"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-red-400 text-sm"></i>}
                  {item.trend === 'same' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            话题广场
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            大家都在讨论什么
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            热门电影话题一网打尽，找到同好一起聊
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className="inline-flex items-center gap-2 px-5 py-3 bg-background-50 hover:bg-background-200/60 border border-background-200/70 rounded-xl transition-colors cursor-pointer no-underline"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.name}</span>
              <span className="text-xs text-foreground-500 bg-background-200 px-2 py-0.5 rounded-full whitespace-nowrap">
                {topic.count.toLocaleString()} 部
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}